import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Modal, Button, Form, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";

const NotesModalNew = (props) => {
  const { notesShow, setNotesShow, noteUserId, userNote, selectedRow, setNoteNew } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [note, setNote] = useState(userNote != '' ? userNote : null);

  const handleCloseModal = () => {
    setNotesShow(false)
  }

  useEffect(() => {

  }, [notesShow])

  const addNotetoRawData = async () => {
    setIsLoading(true)
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');

    const formData = new FormData();
    formData.append("LD_SID", noteUserId)
    formData.append("note", note)
    const res = await axios.post(path + '/classes/add-note', formData, {
      headers: {
        'Content-Type': 'Application/json',
        'Accept': 'Application/json',
        'Authorization': ` ${token}`
      }
    })
    // const res = response.data;
    if (res.data.status === 200) {
      setIsLoading(false)
      toast.success(res?.data?.message)
      setNoteNew(note)
      setNotesShow(false)
    } else {
      // console.log(res)
      toast.error('Please add note to update.')
      // toast.error(res.data.message)
      setIsLoading(false)
    }
  }
  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={notesShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Notes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: '10px' }}>
            {note || 'No notes added'}
          </div>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            {/* <Button variant="primary" onClick={() => {
              addNotetoRawData()
            }}>
              Save Changes
            </Button> */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default NotesModalNew